import { v4 as uuidv4 } from 'uuid';
import { isHostIncludesRefferer } from "utils/locationHelper";

class formService {

    async sendFormData<T>(data: T, form: string) {
        const body = {
            requestId: uuidv4(),
            form:     form,
            referer: `${(document.referrer && !isHostIncludesRefferer(document.location.host, document.referrer) ? document.referrer : "")}`,
            startURL: document.location.href,
            payload:  {...data, url: document.location.href}
        }

        return fetch(`${process.env.REACT_APP_FORM_CALLBACK}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
                Authorization:  `Bearer ${process.env.REACT_APP_FORMCALLBACK_KEY}`
            },
            body: JSON.stringify(body) 
        })
    }


}

export default new formService();